import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { getStats } from "@/lib/api";

export default function Dashboard() {
  const { user, authReady, logout } = useApp();
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);

  const isStaff = user && (user.role === "admin" || user.role === "trainer");

  useEffect(() => {
    if (authReady && !user) navigate("/login");
    else if (authReady && user && !isStaff) navigate("/app");
  }, [authReady, user, isStaff, navigate]);

  useEffect(() => {
    if (isStaff) getStats().then(setStats).catch(() => {});
  }, [isStaff]);

  if (!authReady || !user) {
    return <div className="rbl-auth-wrap"><div className="rbl-spinner" /></div>;
  }

  return (
    <div className="rbl" data-testid="dashboard-page">
      <header className="rbl-topbar">
        <div className="rbl-topbar-inner">
          <div className="rbl-logos">
            <img className="rbl-logo" src="/logo_rbl.png" alt="RBL Training" />
          </div>
          <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
            <Link to="/" className="rbl-link">Hub</Link>
            <button className="rbl-link" onClick={logout} data-testid="logout-btn" style={{ border: "none", background: "none" }}>Log out</button>
          </div>
        </div>
      </header>

      <div className="rbl-wrap" style={{ paddingTop: 40, paddingBottom: 40 }}>
        <div className="rbl-eyebrow">{isStaff ? "ADMIN / TRAINER" : "PARTICIPANT APP"}</div>
        <h1 className="rbl-h1" style={{ fontSize: 40 }} data-testid="dashboard-welcome">
          Welcome, {user.full_name || user.email}
        </h1>
        <div className="rbl-org">{user.email} · {user.role}</div>

        {isStaff && stats && (
          <div className="rbl-grid" style={{ marginTop: 28 }} data-testid="admin-stats">
            {[
              ["Users", stats.users], ["Participants", stats.participants],
              ["Logged in", stats.logged_in], ["Groups", stats.groups],
              ["Programs", stats.programs],
              ["Worksheets", stats.worksheets], ["Quizzes", stats.quizzes],
              ["Materials", stats.materials], ["Commitments", stats.commitments],
            ].map(([label, val]) => (
              <div className="rbl-card" key={label} style={{ alignItems: "flex-start" }}>
                <span className="rbl-card-num">{label.toUpperCase()}</span>
                <span style={{ fontSize: 38, fontWeight: 800, color: "var(--navy)" }}>{val}</span>
              </div>
            ))}
          </div>
        )}

        <div className="rbl-feature" style={{ marginTop: 28 }}>
          <h3>🚧 Phase 2 & 3</h3>
          <p>The full participant app (journal, worksheets-on-server, quizzes) and the admin back-office (users, groups, content, live, reflections, data export, bulk-resend) are scheduled next. Your data is fully migrated and login is working.</p>
        </div>
      </div>
    </div>
  );
}
